import { Link } from "react-router-dom";
import { currentBrand } from "@/lib/brand";

/**
 * The brand identity bar shown at the top of every public route. The brand
 * is selected from the current host via src/lib/brand.ts — see that file to
 * add or change brand entries.
 */
export default function BrandHeader({
  rightSlot,
}: {
  rightSlot?: React.ReactNode;
}) {
  const brand = currentBrand();
  return (
    <header className="border-b">
      <div className="container flex h-14 items-center justify-between">
        <Link to="/dashboard" className="font-semibold">
          {brand.name}
        </Link>
        <div className="flex items-center gap-3 text-sm">{rightSlot}</div>
      </div>
    </header>
  );
}
